function stageAnimalChipId({ animalStore, animalId, value }) {
    if (!animalId) {
        return;
    }
    animalStore.updateObjectKeyValue('animal', 'chipId', value);
    animalStore.updateField(animalId, 'chipId', value);
}

function stageJournalAnimalChipId({ journalStore, animalStore, animalId, value }) {
    journalStore.updateObjectKeyValue('newJournal', 'animalChipId', value);
    stageAnimalChipId({ animalStore, animalId, value });
}

function saveJournalAnimalChipId({ journalStore, journalId, value }) {
    if (!journalId) {
        return Promise.resolve(null);
    }
    return journalStore.saveField(journalId, 'animalChipId', value, true);
}

export { stageAnimalChipId, stageJournalAnimalChipId, saveJournalAnimalChipId };
